/**
 * @file Textarea atom — multi-line text input compound family.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Textarea
 */
export { Textarea, TextareaInput } from "@/components/ui/textarea";
